let scriptsLoaded = false
let loadingScripts = false

export default {
    methods: {
        loadScript(url) {
            return new Promise((resolve, reject) => {
                if (url.endsWith('.css')) {
                    const link = document.createElement('link')
                    link.rel = 'stylesheet'
                    link.type = 'text/css'
                    link.href = url
                    link.onload = resolve
                    link.onerror = reject
                    document.head.appendChild(link)
                } else {
                    const script = document.createElement('script')
                    script.src = url
                    script.onload = resolve
                    script.onerror = reject
                    document.head.appendChild(script)
                }
            })
        },
        async loadExternalScripts() {
            if (scriptsLoaded || loadingScripts) return

            loadingScripts = true

            try {
                await this.loadScript(
                    'https://code.jquery.com/jquery-3.5.0.min.js'
                )
                await this.loadScript(
                    'https://cdn.paymentez.com/ccapi/sdk/payment_sdk_stable.min.css'
                )
                await this.loadScript(
                    'https://cdn.paymentez.com/ccapi/sdk/payment_sdk_stable.min.js'
                )
                await this.loadScript(
                    'https://cdn.paymentez.com/ccapi/sdk/payment_checkout_3.0.0.min.js'
                )
                scriptsLoaded = true
            } catch (error) {
                this.$swal({
                    title: 'Error!',
                    text: 'No se pudieron cargar los scripts de pago. Por favor, recargue la página e intente nuevamente.',
                    icon: 'error',
                    customClass: {
                        confirmButton: 'btn btn-danger',
                    },
                    buttonsStyling: false,
                })
            } finally {
                loadingScripts = false
            }
        },
        async waitForPaymentCheckout() {
            if (!scriptsLoaded) {
                await this.loadExternalScripts()
            }

            return new Promise((resolve, reject) => {
                let attempts = 0
                const maxAttempts = 50 // Limitar a 50 intentos

                const checkPaymentCheckout = () => {
                    // eslint-disable-next-line no-undef
                    if (typeof PaymentCheckout !== 'undefined') {
                        // eslint-disable-next-line no-undef
                        resolve(PaymentCheckout)
                    } else if (attempts < maxAttempts) {
                        attempts += 1
                        setTimeout(checkPaymentCheckout, 100)
                    } else {
                        reject(new Error('PaymentCheckout no está disponible.'))
                    }
                }
                checkPaymentCheckout()
            })
        },
    },
}
